module.exports = __webpack_public_path__ + "img/035.0b5f66cf.png";